export const gradeOptions = [
  { value: "roles.elementary", label: "roles.elementary" },
  { value: "roles.middleSchool", label: "roles.middleSchool" },
  { value: "roles.highSchool", label: "roles.highSchool" },
  {
    value: "roles.higherEducation",
    label: "roles.higherEducation",
  },
  { value: "roles.professional", label: "roles.professional" },
];

export const roleOptions = [
  { value: "roles.teacher", label: "roles.teacher" },
  { value: "roles.administrator", label: "roles.administrator" },
  { value: "roles.schoolAdministrator", label: "roles.schoolAdministrator" },
  {
    value: "roles.districtAdministrator",
    label: "roles.districtAdministrator",
  },
  {
    value: "roles.technologyAdministrator",
    label: "roles.technologyAdministrator",
  },
  { value: "roles.instructionalCoach", label: "roles.instructionalCoach" },
  {
    value: "roles.libraryMediaSpecialist",
    label: "roles.libraryMediaSpecialist",
  },
  { value: "roles.other", label: "roles.other" },
];

export const schoolOptions = [
  {
    value: "ÖZEL HEYBELİADA RUM ERKEK LİSESİ",
    label: "ÖZEL HEYBELİADA RUM ERKEK LİSESİ",
  },
  {
    value: "ÖZEL ARNAVUTKÖY FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ARNAVUTKÖY FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ARNAVUTKÖY KUDÜS MİLLETLERARASI LİSESİ",
    label: "ÖZEL ARNAVUTKÖY KUDÜS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BOLLUCA UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BOLLUCA UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HADIMKÖY FİNAL ANADOLU LİSESİ",
    label: "ÖZEL HADIMKÖY FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜNSAL ANADOLU LİSESİ",
    label: "ÖZEL ÜNSAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YENİ KARİYERİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL YENİ KARİYERİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BOSTANCI DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BOSTANCI DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ANABİLİM ANADOLU LİSESİ",
    label: "ÖZEL ANABİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ANABİLİM FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL ANABİLİM FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL AŞAMA ANADOLU LİSESİ",
    label: "ÖZEL AŞAMA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AŞAMA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL AŞAMA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR AÇI ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR BİLGİ KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR BİLGİ KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR GÖKKUŞAĞI ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR GÖKKUŞAĞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR MODERN BİLİMLER AKADEMİSİ (MBA) ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR MODERN BİLİMLER AKADEMİSİ (MBA) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR OKYANUS FEN LİSESİ",
    label: "ÖZEL ATAŞEHİR OKYANUS FEN LİSESİ",
  },
  {
    value: "ÖZEL ATAŞEHİR UĞUR ANADOLU LİSESİ",
    label: "ÖZEL ATAŞEHİR UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLGİN ANADOLU LİSESİ",
    label: "ÖZEL BİLGİN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BOSTANCI DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL BOSTANCI DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL DENİZATI ANADOLU LİSESİ",
    label: "ÖZEL DENİZATI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DOĞRU VE RASYONEL AKŞAM LİSESİ",
    label: "ÖZEL DOĞRU VE RASYONEL AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL DOĞRU VE RASYONEL ANADOLU LİSESİ",
    label: "ÖZEL DOĞRU VE RASYONEL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DOĞU ATAŞEHİR BİL ANADOLU LİSESİ",
    label: "ÖZEL DOĞU ATAŞEHİR BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FERHATPAŞA AŞAMA ANADOLU LİSESİ",
    label: "ÖZEL FERHATPAŞA AŞAMA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FİNAL ANADOLU LİSESİ",
    label: "ÖZEL FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KUZEY ANADOLU LİSESİ",
    label: "ÖZEL KUZEY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PRESTİJ ANADOLU LİSESİ",
    label: "ÖZEL PRESTİJ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SEVİNÇ ATAŞEHİR GÜRBÜZ BOY ANADOLU LİSESİ",
    label: "ÖZEL SEVİNÇ ATAŞEHİR GÜRBÜZ BOY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE AŞAMA AKŞAM LİSESİ",
    label: "ÖZEL ÜMRANİYE AŞAMA AKŞAM LİSESİ",
  },
  {
    value: "FMV ÖZEL ISPARTAKULE IŞIK FEN LİSESİ",
    label: "FMV ÖZEL ISPARTAKULE IŞIK FEN LİSESİ",
  },
  {
    value: "FMV ÖZEL ISPARTAKULE IŞIK LİSESİ",
    label: "FMV ÖZEL ISPARTAKULE IŞIK LİSESİ",
  },
  {
    value: "ÖZEL AL NAHDA MİLLETLERARASI LİSESİ",
    label: "ÖZEL AL NAHDA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ARTI AKŞAM LİSESİ",
    label: "ÖZEL ARTI AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR BİL ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR BİLİM DOĞA ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR BİLİM DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR ÇİZGİ YAZILIM ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR ÇİZGİ YAZILIM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR DENİZ AKŞAM LİSESİ",
    label: "ÖZEL AVCILAR DENİZ AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR FİNAL ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR KOZMOS YAZILIM ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR KOZMOS YAZILIM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR OĞUZKAAN KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR OĞUZKAAN KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AVCILAR SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL AVCILAR SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİM VE YAŞAM MERKEZİ OKYANUS LİSESİ",
    label: "ÖZEL EĞİTİM VE YAŞAM MERKEZİ OKYANUS LİSESİ",
  },
  {
    value: "ÖZEL HASEKİ KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL HASEKİ KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HASEKİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL HASEKİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL OKYANUS FEN VE PROJE LİSESİ",
    label: "ÖZEL OKYANUS FEN VE PROJE LİSESİ",
  },
  {
    value: "ÖZEL AWAEL MİLLETLERARASI LİSESİ",
    label: "ÖZEL AWAEL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL AYTAŞI AKŞAM LİSESİ",
    label: "ÖZEL AYTAŞI AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL BAĞCILAR ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL BAĞCILAR ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAĞCILAR UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BAĞCILAR UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAĞCILAR VATAN ANADOLU LİSESİ",
    label: "ÖZEL BAĞCILAR VATAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİRİKİM HAYAT ANADOLU LİSESİ",
    label: "ÖZEL BİRİKİM HAYAT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİRİKİM HAYAT FEN LİSESİ",
    label: "ÖZEL BİRİKİM HAYAT FEN LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ BAŞER AKŞAM LİSESİ",
    label: "ÖZEL GÜNEŞLİ BAŞER AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ FİNAL ANADOLU LİSESİ",
    label: "ÖZEL GÜNEŞLİ FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ FİNAL FEN LİSESİ",
    label: "ÖZEL GÜNEŞLİ FİNAL FEN LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ SINAV ANADOLU LİSESİ",
    label: "ÖZEL GÜNEŞLİ SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ SINAV FEN LİSESİ",
    label: "ÖZEL GÜNEŞLİ SINAV FEN LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL DÜZGÜN AKŞAM LİSESİ",
    label: "ÖZEL İSTANBUL DÜZGÜN AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL HAYAT MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL HAYAT MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAZANIM ANADOLU LİSESİ",
    label: "ÖZEL KAZANIM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAZANIM MİLLETLERARASI LİSESİ",
    label: "ÖZEL KAZANIM MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL MEKTEBİM GÜNEŞLİ KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL MEKTEBİM GÜNEŞLİ KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MİLESTONE MİLLETLERARASI LİSESİ",
    label: "ÖZEL MİLESTONE MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL MODERN TULİB EL FAİZUN MİLLETLERARASI LİSESİ",
    label: "ÖZEL MODERN TULİB EL FAİZUN MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL YENİAY ANADOLU LİSESİ",
    label: "ÖZEL YENİAY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKKUŞAĞI ANADOLU LİSESİ",
    label: "ÖZEL GÖKKUŞAĞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İHLAS ANADOLU LİSESİ",
    label: "ÖZEL İHLAS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AREL ANADOLU LİSESİ",
    label: "ÖZEL AREL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AREL FEN LİSESİ",
    label: "ÖZEL AREL FEN LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER BİREY ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER CUMHURİYET FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER CUMHURİYET FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER İNCİRLİ BİREY ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER İNCİRLİ BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER SEVİNÇ ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER SEVİNÇ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER ŞAFAK ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER ŞAFAK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER TULİP MİLLETLERARASI LİSESİ",
    label: "ÖZEL BAHÇELİEVLER TULİP MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BAHÇELİEVLER YENİBOSNA FİNAL ANADOLU LİSESİ",
    label: "ÖZEL BAHÇELİEVLER YENİBOSNA FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BASIN EKSPRES UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BASIN EKSPRES UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞARILI ANADOLU LİSESİ",
    label: "ÖZEL BAŞARILI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLİM KÜLTÜR AKŞAM LİSESİ",
    label: "ÖZEL BİLİM KÜLTÜR AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL BİLİM KÜLTÜR ANADOLU LİSESİ",
    label: "ÖZEL BİLİM KÜLTÜR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇALIŞLAR BOĞAZİÇİ ANADOLU LİSESİ",
    label: "ÖZEL ÇALIŞLAR BOĞAZİÇİ ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA ) KOLEJİ KOCASİNAN ANADOLU LİSESİ",
    label:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA ) KOLEJİ KOCASİNAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EL MAARİFE MİLLETLERARASI LİSESİ",
    label: "ÖZEL EL MAARİFE MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ELİT GENÇLER AKŞAM LİSESİ",
    label: "ÖZEL ELİT GENÇLER AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL GÜNEŞLİ DOĞA ANADOLU LİSESİ",
    label: "ÖZEL GÜNEŞLİ DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İHLAS FEN LİSESİ",
    label: "ÖZEL İHLAS FEN LİSESİ",
  },
  {
    value: "ÖZEL MAHMUT ÖN ANADOLU LİSESİ",
    label: "ÖZEL MAHMUT ÖN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MÜSTAKBEL MİLLETLERARASI LİSESİ",
    label: "ÖZEL MÜSTAKBEL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ BAHÇELİEVLER ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ BAHÇELİEVLER ANADOLU LİSESİ",
  },
  {
    value: "FMV ÖZEL FLORYA IŞIK LİSESİ",
    label: "FMV ÖZEL FLORYA IŞIK LİSESİ",
  },
  {
    value: "İSTEK ÖZEL BİLGE KAĞAN ANADOLU LİSESİ",
    label: "İSTEK ÖZEL BİLGE KAĞAN ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL BİLGE KAĞAN FEN LİSESİ",
    label: "İSTEK ÖZEL BİLGE KAĞAN FEN LİSESİ",
  },
  {
    value: "MEV KOLEJİ ÖZEL BASINKÖY ANADOLU LİSESİ",
    label: "MEV KOLEJİ ÖZEL BASINKÖY ANADOLU LİSESİ",
  },
  {
    value: "MEV KOLEJİ ÖZEL BASINKÖY FEN LİSESİ",
    label: "MEV KOLEJİ ÖZEL BASINKÖY FEN LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY AKŞAM LİSESİ",
    label: "ÖZEL BAKIRKÖY AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY DİL VE KONUŞMA ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY DİL VE KONUŞMA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY GEN ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY GEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY ONUR MEYNİOĞLU ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY ONUR MEYNİOĞLU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY SINAV ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAKIRKÖY YENİLİK ANADOLU LİSESİ",
    label: "ÖZEL BAKIRKÖY YENİLİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CESUR NİTELİKLİ DİNAMİK KOLEJİ (CND) ANADOLU LİSESİ",
    label: "ÖZEL CESUR NİTELİKLİ DİNAMİK KOLEJİ (CND) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FLORYA ANADOLU LİSESİ",
    label: "ÖZEL FLORYA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FLORYA BİREY ANADOLU LİSESİ",
    label: "ÖZEL FLORYA BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FLORYA FEN LİSESİ",
    label: "ÖZEL FLORYA FEN LİSESİ",
  },
  {
    value: "ÖZEL FLORYA FİNAL ANADOLU LİSESİ",
    label: "ÖZEL FLORYA FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADRO ANADOLU LİSESİ",
    label: "ÖZEL KADRO ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜLTÜR LİSESİ",
    label: "ÖZEL KÜLTÜR LİSESİ",
  },
  {
    value: "ÖZEL KÜLTÜR FEN LİSESİ",
    label: "ÖZEL KÜLTÜR FEN LİSESİ",
  },
  {
    value: "ÖZEL MODERN NİTELİKLİ EĞİTİM KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL MODERN NİTELİKLİ EĞİTİM KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ŞENLİKKÖY BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ŞENLİKKÖY BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ŞENLİKKÖY BAHÇEŞEHİR KOLEJİ FEN LİSESİ",
    label: "ÖZEL ŞENLİKKÖY BAHÇEŞEHİR KOLEJİ FEN LİSESİ",
  },
  {
    value: "ÖZEL YAVUZLAR ANADOLU LİSESİ",
    label: "ÖZEL YAVUZLAR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HUDA SCHOOLS MİLLETLERARASI LİSESİ",
    label: "ÖZEL HUDA SCHOOLS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR BİLFEN ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR BİLFEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALNOOR MİLLETLERARASI LİSESİ",
    label: "ÖZEL ALNOOR MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR ARTI ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR ARTI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR BİLFEN FEN LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR BİLFEN FEN LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR FİNAL AKADEMİ FEN LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR FİNAL AKADEMİ FEN LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR VİZYON ANADOLU LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR VİZYON ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR BİREY ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR DOĞA ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL BAŞAKŞEHİR EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ ANADOLU LİSESİ",
    label:
      "ÖZEL BAŞAKŞEHİR EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR FİNAL ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR FİNAL FEN LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR FİNAL FEN LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR TARHAN KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR TARHAN KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR YENİDOĞU ANADOLU LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR YENİDOĞU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAŞAKŞEHİR YENİDOĞU FEN LİSESİ",
    label: "ÖZEL BAŞAKŞEHİR YENİDOĞU FEN LİSESİ",
  },
  {
    value: "ÖZEL CİHANGİR ANADOLU LİSESİ",
    label: "ÖZEL CİHANGİR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇINAR ANADOLU LİSESİ",
    label: "ÖZEL ÇINAR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇINAR FEN LİSESİ",
    label: "ÖZEL ÇINAR FEN LİSESİ",
  },
  {
    value: "ÖZEL ENDÜLÜS MİLLETLERARASI LİSESİ",
    label: "ÖZEL ENDÜLÜS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL HÜDA ANADOLU LİSESİ",
    label: "ÖZEL HÜDA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HÜDA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL HÜDA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL İHSAN PREMIER MİLLETLERARASI LİSESİ",
    label: "ÖZEL İHSAN PREMIER MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL İKİTELLİ OSB MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL İKİTELLİ OSB MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL AKADEMİK SİSTEM OKULLARI ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL AKADEMİK SİSTEM OKULLARI ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL İSTANBUL ORGANİZE SANAYİ BÖLGESİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL İSTANBUL ORGANİZE SANAYİ BÖLGESİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KENT MEKTEBİ ANADOLU LİSESİ",
    label: "ÖZEL KENT MEKTEBİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KUDÜS MİLLETLERARASI LİSESİ",
    label: "ÖZEL KUDÜS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL MANARA MİLLETLERARASI LİSESİ",
    label: "ÖZEL MANARA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL SADIK YAMANOĞLU ANADOLU LİSESİ",
    label: "ÖZEL SADIK YAMANOĞLU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SADIK YAMANOĞLU FEN LİSESİ",
    label: "ÖZEL SADIK YAMANOĞLU FEN LİSESİ",
  },
  {
    value: "ÖZEL SENA MİLLETLERARASI LİSESİ",
    label: "ÖZEL SENA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL SİNERJİ ANADOLU LİSESİ",
    label: "ÖZEL SİNERJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL THINK INTERNATIONAL SCHOOLS MİLLETLERARASI LİSESİ",
    label: "ÖZEL THINK INTERNATIONAL SCHOOLS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL VİZYON ANADOLU LİSESİ",
    label: "ÖZEL VİZYON ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YENİDOĞU ANADOLU LİSESİ",
    label: "ÖZEL YENİDOĞU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA AKŞAM LİSESİ",
    label: "ÖZEL BAYRAMPAŞA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA ANADOLU LİSESİ",
    label: "ÖZEL BAYRAMPAŞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL BAYRAMPAŞA NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL BAYRAMPAŞA OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA OKYANUS FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL BAYRAMPAŞA OKYANUS FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL BAYRAMPAŞA SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BAYRAMPAŞA SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ATANUR OĞUZ FEN LİSESİ",
    label: "İSTEK ÖZEL ATANUR OĞUZ FEN LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ATANUR OĞUZ ANADOLU LİSESİ",
    label: "İSTEK ÖZEL ATANUR OĞUZ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AMERİKAN ROBERT LİSESİ",
    label: "ÖZEL AMERİKAN ROBERT LİSESİ",
  },
  {
    value: "ÖZEL BEBEK UĞUR ANADOLU LİSESİ",
    label: "ÖZEL BEBEK UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEŞİKTAŞ BİREY ANADOLU LİSESİ",
    label: "ÖZEL BEŞİKTAŞ BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ETİLER AÇI ANADOLU LİSESİ",
    label: "ÖZEL ETİLER AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ETİLER EL EV FEN LİSESİ",
    label: "ÖZEL ETİLER EL EV FEN LİSESİ",
  },
  {
    value: "ÖZEL MEF LİSESİ",
    label: "ÖZEL MEF LİSESİ",
  },
  {
    value: "ÖZEL MEF FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL MEF FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL MEF ULUSLARARASI LİSESİ",
    label: "ÖZEL MEF ULUSLARARASI LİSESİ",
  },
  {
    value: "T.V. ÖZEL ŞİŞLİ TERAKKİ FEN LİSESİ",
    label: "T.V. ÖZEL ŞİŞLİ TERAKKİ FEN LİSESİ",
  },
  {
    value: "T.V.ÖZEL ŞİŞLİ TERAKKİ LİSESİ",
    label: "T.V.ÖZEL ŞİŞLİ TERAKKİ LİSESİ",
  },
  {
    value: "ULUS ÖZEL MUSEVİ LİSESİ",
    label: "ULUS ÖZEL MUSEVİ LİSESİ",
  },
  {
    value: "ÖZEL ACARKENT DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ACARKENT DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYKOZ DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BEYKOZ DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYKOZ FİNAL ANADOLU LİSESİ",
    label: "ÖZEL BEYKOZ FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAVACIK AÇI ANADOLU LİSESİ",
    label: "ÖZEL KAVACIK AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAVACIK SINAV ANADOLU LİSESİ",
    label: "ÖZEL KAVACIK SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAZDALLAR BİLİM ANADOLU LİSESİ",
    label: "ÖZEL KAZDALLAR BİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ BEYKOZ ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ BEYKOZ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NUN ANADOLU LİSESİ",
    label: "ÖZEL NUN ANADOLU LİSESİ",
  },
  {
    value: "TED İSTANBUL KOLEJİ VAKFI ÖZEL LİSESİ",
    label: "TED İSTANBUL KOLEJİ VAKFI ÖZEL LİSESİ",
  },
  {
    value: "ÖZEL AKSA DÜNYA KOLEJİ MİLLETLERARASI LİSESİ",
    label: "ÖZEL AKSA DÜNYA KOLEJİ MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ALMUSTAKBAL MİLLETLERARASI LİSESİ",
    label: "ÖZEL ALMUSTAKBAL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL AR EV ANADOLU LİSESİ",
    label: "ÖZEL AR EV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL AR EV FEN LİSESİ",
    label: "ÖZEL AR EV FEN LİSESİ",
  },
  {
    value: "ÖZEL BEYFEN KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BEYFEN KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYKENT DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BEYKENT DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYKENT OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL BEYKENT OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ AÇI ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ BİLNET ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ BİLNET ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL BEYLİKDÜZÜ CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
    label:
      "ÖZEL BEYLİKDÜZÜ CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ EĞİTİMDE TEK ADRES KOLEJİ (ETA) ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ EĞİTİMDE TEK ADRES KOLEJİ (ETA) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ FİNAL ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ GÖKKUŞAĞI ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ GÖKKUŞAĞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ MEDENİYET ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ MEDENİYET ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ MODERN EĞİTİM KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ MODERN EĞİTİM KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ MODERN EĞİTİM KOLEJİ FEN LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ MODERN EĞİTİM KOLEJİ FEN LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ OĞUZKAAN ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ OĞUZKAAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ SINAV ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ TEKNOLOJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ TEKNOLOJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ TULİP MİLLETLERARASI LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ TULİP MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BİLİM YAŞAM ANADOLU LİSESİ",
    label: "ÖZEL BİLİM YAŞAM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLİM YAŞAM FEN LİSESİ",
    label: "ÖZEL BİLİM YAŞAM FEN LİSESİ",
  },
  {
    value: "ÖZEL DOLMABAHÇE BİLİŞİM ANADOLU LİSESİ",
    label: "ÖZEL DOLMABAHÇE BİLİŞİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DOLMABAHÇE HAVACILIK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL DOLMABAHÇE HAVACILIK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ BEYKENT ANADOLU LİSESİ",
    label: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ BEYKENT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FİLİSTİN AL FANAR MİLLETLERARASI LİSESİ",
    label: "ÖZEL FİLİSTİN AL FANAR MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL GLOBAL EĞİTİM KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL GLOBAL EĞİTİM KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İLHAN KOCA AKŞAM LİSESİ",
    label: "ÖZEL İLHAN KOCA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL İLHAN KOCA ANADOLU LİSESİ",
    label: "ÖZEL İLHAN KOCA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜRESEL EĞİTİM YAKLAŞIMI (KEY) ANADOLU LİSESİ",
    label: "ÖZEL KÜRESEL EĞİTİM YAKLAŞIMI (KEY) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MANAR MİLLETLERARASI LİSESİ",
    label: "ÖZEL MANAR MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL MARMARA EVLERİ İHLAS ANADOLU LİSESİ",
    label: "ÖZEL MARMARA EVLERİ İHLAS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MARMARA EVLERİ İHLAS FEN LİSESİ",
    label: "ÖZEL MARMARA EVLERİ İHLAS FEN LİSESİ",
  },
  {
    value: "ÖZEL MODERN ENGLİSH İNTERNATİONAL SCHOOL MİLLETLERARASI LİSESİ",
    label: "ÖZEL MODERN ENGLİSH İNTERNATİONAL SCHOOL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL NEW VİSİON MİLLETLERARASI LİSESİ",
    label: "ÖZEL NEW VİSİON MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL NİTELİKLİ VE İLERİ SİSTEM(NVİS) ANADOLU LİSESİ",
    label: "ÖZEL NİTELİKLİ VE İLERİ SİSTEM(NVİS) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SULTAN FATİH ANADOLU LİSESİ",
    label: "ÖZEL SULTAN FATİH ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL VİZYON ANADOLU LİSESİ",
    label: "ÖZEL VİZYON ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YAKUPLU BAŞER AKŞAM LİSESİ",
    label: "ÖZEL YAKUPLU BAŞER AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ALMAN LİSESİ",
    label: "ÖZEL ALMAN LİSESİ",
  },
  {
    value: "ÖZEL BEYOĞLU DOĞA ANADOLU LİSESİ",
    label: "ÖZEL BEYOĞLU DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESAYAN ERMENİ LİSESİ",
    label: "ÖZEL ESAYAN ERMENİ LİSESİ",
  },
  {
    value: "ÖZEL GALİLEO GALİLEİ İTALYAN LİSESİ",
    label: "ÖZEL GALİLEO GALİLEİ İTALYAN LİSESİ",
  },
  {
    value: "ÖZEL GETRONAGAN ERMENİ ANADOLU LİSESİ",
    label: "ÖZEL GETRONAGAN ERMENİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İTALYAN LİSESİ",
    label: "ÖZEL İTALYAN LİSESİ",
  },
  {
    value: "ÖZEL SAINT BENOIT FRANSIZ LİSESİ",
    label: "ÖZEL SAINT BENOIT FRANSIZ LİSESİ",
  },
  {
    value: "ÖZEL SAINTE PULCHERIE FRANSIZ LİSESİ",
    label: "ÖZEL SAINTE PULCHERIE FRANSIZ LİSESİ",
  },
  {
    value: "ÖZEL SANKT GEORG AVUSTURYA LİSESİ VE TİCARET OKULU",
    label: "ÖZEL SANKT GEORG AVUSTURYA LİSESİ VE TİCARET OKULU",
  },
  {
    value: "ÖZEL ZAPYON RUM LİSESİ",
    label: "ÖZEL ZAPYON RUM LİSESİ",
  },
  {
    value: "ÖZEL ZOĞRAFYON RUM LİSESİ VE TİCARET OKULU",
    label: "ÖZEL ZOĞRAFYON RUM LİSESİ VE TİCARET OKULU",
  },
  {
    value: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL ANAOKULU",
    label: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL ANAOKULU",
  },
  {
    value: "ALMAN LİSELİLER KÜLTÜR EĞİTİM VAKFI ÖZEL ANADOLU LİSESİ",
    label: "ALMAN LİSELİLER KÜLTÜR EĞİTİM VAKFI ÖZEL ANADOLU LİSESİ",
  },
  {
    value: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL FEN LİSESİ",
    label: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL FEN LİSESİ",
  },
  {
    value: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL İLKOKULU",
    label: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL İLKOKULU",
  },
  {
    value: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL ORTAOKULU",
    label: "ALMAN LİSELİLER KÜLTÜR VE EĞİTİM VAKFI ÖZEL ORTAOKULU",
  },
  {
    value: "BÜYÜKÇEKMECE ÖZEL CİHANGİR ANADOLU LİSESİ",
    label: "BÜYÜKÇEKMECE ÖZEL CİHANGİR ANADOLU LİSESİ",
  },
  {
    value: "MEV KOLEJİ ÖZEL BÜYÜKÇEKMECE ANADOLU LİSESİ",
    label: "MEV KOLEJİ ÖZEL BÜYÜKÇEKMECE ANADOLU LİSESİ",
  },
  {
    value: "MEV KOLEJİ ÖZEL BÜYÜKÇEKMECE FEN LİSESİ",
    label: "MEV KOLEJİ ÖZEL BÜYÜKÇEKMECE FEN LİSESİ",
  },
  {
    value: "MİMAR SİNAN ÖZEL ANADOLU LİSESİ",
    label: "MİMAR SİNAN ÖZEL ANADOLU LİSESİ",
  },
  {
    value: "MİMAR SİNAN ÖZEL FEN LİSESİ",
    label: "MİMAR SİNAN ÖZEL FEN LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMECE DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMECE DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ERKAN AKŞAM LİSESİ",
    label: "ÖZEL ERKAN AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL AKYAKA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL AKYAKA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BRIGHTS MİLLETLERARASI LİSESİ",
    label: "ÖZEL BRIGHTS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BÜYÜKÇEKMECE AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL BÜYÜKÇEKMECE AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BÜYÜKÇEKMECE AKADEMİ FEN LİSESİ",
    label: "ÖZEL BÜYÜKÇEKMECE AKADEMİ FEN LİSESİ",
  },
  {
    value: "ÖZEL BÜYÜKÇEKMECE BİLNET ANADOLU LİSESİ",
    label: "ÖZEL BÜYÜKÇEKMECE BİLNET ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BÜYÜKÇEKMECE FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL BÜYÜKÇEKMECE FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMECE DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL ÇEKMECE DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL DİLA AKŞAM LİSESİ",
    label: "ÖZEL DİLA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ERİŞ ANADOLU LİSESİ",
    label: "ÖZEL ERİŞ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL INTERNATIONAL COMMUNITY SCHOOL MİLLETLERARASI LİSESİ",
    label: "ÖZEL INTERNATIONAL COMMUNITY SCHOOL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL KABATAŞ TEKNOLOJİ ANADOLU LİSESİ",
    label: "ÖZEL KABATAŞ TEKNOLOJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KUMBURGAZ GURUR MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL KUMBURGAZ GURUR MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜLTÜR 2000 FEN LİSESİ",
    label: "ÖZEL KÜLTÜR 2000 FEN LİSESİ",
  },
  {
    value: "ÖZEL MİMAROBA SINAV ANADOLU LİSESİ",
    label: "ÖZEL MİMAROBA SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MİMARSİNAN OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL MİMARSİNAN OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YÖNELİM AKŞAM LİSESİ",
    label: "ÖZEL YÖNELİM AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL YÖNELİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL YÖNELİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇATALCA ÇEVRE BİLİM ANADOLU LİSESİ",
    label: "ÖZEL ÇATALCA ÇEVRE BİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇATALCA FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL ÇATALCA FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL ANADOLU LİSESİ",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL ANADOLU LİSESİ",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125. YIL ANAOKULU",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125. YIL ANAOKULU",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125.YIL İLKOKULU",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125.YIL İLKOKULU",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125.YIL ORTAOKULU",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL 125.YIL ORTAOKULU",
  },
  {
    value: "ÖZEL ÇEKMEKÖY GİRNE KOLEJİ FEN LİSESİ",
    label: "ÖZEL ÇEKMEKÖY GİRNE KOLEJİ FEN LİSESİ",
  },
  {
    value: "ÖZEL ALEV LİSESİ",
    label: "ÖZEL ALEV LİSESİ",
  },
  {
    value: "ÖZEL BOĞAZİÇİ İLGİ ANADOLU LİSESİ",
    label: "ÖZEL BOĞAZİÇİ İLGİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY DERYA ÖNCÜ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY DERYA ÖNCÜ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY FİNAL ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY FİNAL FEN LİSESİ",
    label: "ÖZEL ÇEKMEKÖY FİNAL FEN LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY GİRNE KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY GİRNE KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY İLETİŞİM AKŞAM LİSESİ",
    label: "ÖZEL ÇEKMEKÖY İLETİŞİM AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY KAVRAM FEN LİSESİ",
    label: "ÖZEL ÇEKMEKÖY KAVRAM FEN LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY MODAFEN ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY MODAFEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY SEVİNÇ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY SEVİNÇ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İLERİ NESİL ANADOLU LİSESİ",
    label: "ÖZEL İLERİ NESİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY İLKOKULU",
    label: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY İLKOKULU",
  },
  {
    value: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY ORTAOKULU",
    label: "ÖZEL KADIKÖY ANADOLU LİSESİ EĞİTİM VAKFI ÇEKMEKÖY ORTAOKULU",
  },
  {
    value: "ÖZEL MERKEZ GİRNE KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL MERKEZ GİRNE KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÖMERLİ BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÖMERLİ BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SEV LİSESİ",
    label: "ÖZEL SEV LİSESİ",
  },
  {
    value: "ÖZEL SEZİN LİSESİ",
    label: "ÖZEL SEZİN LİSESİ",
  },
  {
    value: "ÖZEL YENİ NESİL ÇINAR ANADOLU LİSESİ",
    label: "ÖZEL YENİ NESİL ÇINAR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DEVRAN FEN LİSESİ",
    label: "ÖZEL DEVRAN FEN LİSESİ",
  },
  {
    value: "ÖZEL ESENLER SINAV ANADOLU LİSESİ",
    label: "ÖZEL ESENLER SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL EKSEN ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL EKSEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KEMER BOĞAZİÇİ ANADOLU LİSESİ",
    label: "ÖZEL KEMER BOĞAZİÇİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALMAWAKEB MİLLETLERARASI LİSESİ",
    label: "ÖZEL ALMAWAKEB MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ARDIÇLI UĞUR ANADOLU LİSESİ",
    label: "ÖZEL ARDIÇLI UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ASYA MİLLETLERARASI LİSESİ",
    label: "ÖZEL ASYA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BEYLİKDÜZÜ OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL BEYLİKDÜZÜ OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİZ OKULLARI ANADOLU LİSESİ",
    label: "ÖZEL BİZ OKULLARI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ELİT AKADEMİ MİLLETLERARASI LİSESİ",
    label: "ÖZEL ELİT AKADEMİ MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL EMEL NİNOVA MİLLETLERARASI LİSESİ",
    label: "ÖZEL EMEL NİNOVA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ESENKENT OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL ESENKENT OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESENKENT OKYANUS FEN LİSESİ",
    label: "ÖZEL ESENKENT OKYANUS FEN LİSESİ",
  },
  {
    value: "ÖZEL ESENKENT OKYANUS GÜZEL SANATLAR LİSESİ",
    label: "ÖZEL ESENKENT OKYANUS GÜZEL SANATLAR LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT BİL ANADOLU LİSESİ",
    label: "ÖZEL ESENYURT BİL ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL ESENYURT BİYOTEKNOLOJİ OKULLARI MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL ESENYURT BİYOTEKNOLOJİ OKULLARI MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT BOĞAZİÇİ ANADOLU LİSESİ",
    label: "ÖZEL ESENYURT BOĞAZİÇİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT MENAR MİLLETLERARASI LİSESİ",
    label: "ÖZEL ESENYURT MENAR MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
    label: "ÖZEL ESENYURT MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
    label: "ÖZEL ESENYURT MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
  },
  {
    value:
      "ÖZEL ESENYURT TOPKAPI TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL ESENYURT TOPKAPI TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ESENYURT ZEMAS MİLLETLERARASI LİSESİ",
    label: "ÖZEL ESENYURT ZEMAS MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL FİRUZKÖY MEKTEBİM KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL FİRUZKÖY MEKTEBİM KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKKUŞAĞI ANADOLU LİSESİ",
    label: "ÖZEL GÖKKUŞAĞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HARVEST MİLLETLERARASI LİSESİ",
    label: "ÖZEL HARVEST MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL İHSAN MİLLETLERARASI LİSESİ",
    label: "ÖZEL İHSAN MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL BERK ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL BERK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL BEYOĞLU ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL BEYOĞLU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KURTUBA MİLLETLERARASI LİSESİ",
    label: "ÖZEL KURTUBA MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL MESLEĞİM AKŞAM LİSESİ",
    label: "ÖZEL MESLEĞİM AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL MESLEĞİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL MESLEĞİM MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MUHAMMET ALFATİH MİLLETLERARASI LİSESİ",
    label: "ÖZEL MUHAMMET ALFATİH MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL PARC İNTERNATİONAL SCHOOLS MİLLETLERARASI LİSESİ",
    label: "ÖZEL PARC İNTERNATİONAL SCHOOLS MİLLETLERARASI LİSESİ",
  },
  {
    value:
      "ÖZEL PİRİ REİS TOPKAPI TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL PİRİ REİS TOPKAPI TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL RUMELİ KOLEJİ MİLLETLERARASI LİSESİ",
    label: "ÖZEL RUMELİ KOLEJİ MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL YEDİ RENKLİ ÇINAR ANADOLU LİSESİ",
    label: "ÖZEL YEDİ RENKLİ ÇINAR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YEMENLİLER MİLLETLERARASI LİSESİ",
    label: "ÖZEL YEMENLİLER MİLLETLERARASI LİSESİ",
  },
  {
    value: "TED ÖZEL ATAKENT ANADOLU LİSESİ",
    label: "TED ÖZEL ATAKENT ANADOLU LİSESİ",
  },
  {
    value: "HİSAR EĞİTİM VAKFI ÖZEL HİSAR LİSESİ",
    label: "HİSAR EĞİTİM VAKFI ÖZEL HİSAR LİSESİ",
  },
  {
    value: "ÖZEL ALİBEYKÖY FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ALİBEYKÖY FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEŞEHİR FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL BAHÇEŞEHİR FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA ) KOLEJİ EDİRNEKAPI ANADOLU LİSESİ",
    label:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA ) KOLEJİ EDİRNEKAPI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ HALİÇ ANADOLU LİSESİ",
    label: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ HALİÇ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EYÜPSULTAN BERİL ANADOLU LİSESİ",
    label: "ÖZEL EYÜPSULTAN BERİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EYÜPSULTAN LİDER SANCAK KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL EYÜPSULTAN LİDER SANCAK KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EYÜPSULTAN LİDER SANCAK KOLEJİ FEN LİSESİ",
    label: "ÖZEL EYÜPSULTAN LİDER SANCAK KOLEJİ FEN LİSESİ",
  },
  {
    value: "ÖZEL EYÜPSULTAN TEMEL BİLİMLER MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL EYÜPSULTAN TEMEL BİLİMLER MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKTÜRK DOĞA ANADOLU LİSESİ",
    label: "ÖZEL GÖKTÜRK DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKTÜRK FİNAL ANADOLU LİSESİ",
    label: "ÖZEL GÖKTÜRK FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HALİÇ DOĞA ANADOLU LİSESİ",
    label: "ÖZEL HALİÇ DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İHTİŞAMLAR MİLLETLERARASI LİSESİ",
    label: "ÖZEL İHTİŞAMLAR MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL KEMER LİSESİ",
    label: "ÖZEL KEMER LİSESİ",
  },
  {
    value: "ÖZEL KEMERBURGAZ BAHÇEŞEHİR ANADOLU LİSESİ",
    label: "ÖZEL KEMERBURGAZ BAHÇEŞEHİR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KEMERBURGAZ BİLİM ANADOLU LİSESİ",
    label: "ÖZEL KEMERBURGAZ BİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KEMERBURGAZ OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL KEMERBURGAZ OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KEMERBURGAZ UĞUR ANADOLU LİSESİ",
    label: "ÖZEL KEMERBURGAZ UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SULTANGAZİ FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL SULTANGAZİ FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL İLKOKULU",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL İLKOKULU",
  },
  {
    value: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL ORTAOKULU",
    label: "İSTANBUL ERKEK LİSELİLER EĞİTİM VAKFI ÖZEL ORTAOKULU",
  },
  {
    value: "ÖZEL ÇAPA FİNAL ANADOLU LİSESİ",
    label: "ÖZEL ÇAPA FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FATİH BİRİKİM PROF. DR. NECMETTİN ERBAKAN ANADOLU LİSESİ",
    label: "ÖZEL FATİH BİRİKİM PROF. DR. NECMETTİN ERBAKAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FATİH FİNAL ANADOLU LİSESİ",
    label: "ÖZEL FATİH FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FATİH OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL FATİH OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FATİH SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL FATİH SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FENER RUM LİSESİ",
    label: "ÖZEL FENER RUM LİSESİ",
  },
  {
    value: "ÖZEL SAHAKYAN NUNYAN ERMENİ ANADOLU LİSESİ",
    label: "ÖZEL SAHAKYAN NUNYAN ERMENİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SULTAN FATİH FEN LİSESİ",
    label: "ÖZEL SULTAN FATİH FEN LİSESİ",
  },
  {
    value: "ÖZEL AY ANADOLU LİSESİ",
    label: "ÖZEL AY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA AÇI ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA HAVUZBAŞI MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA HAVUZBAŞI MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA MODERN BİLİMLER AKADEMİSİ (MBA) ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA MODERN BİLİMLER AKADEMİSİ (MBA) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA ŞEFKAT FEN LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA ŞEFKAT FEN LİSESİ",
  },
  {
    value: "ÖZEL GAZİOSMANPAŞA UĞUR ANADOLU LİSESİ",
    label: "ÖZEL GAZİOSMANPAŞA UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MAVİGÜN ANADOLU LİSESİ",
    label: "ÖZEL MAVİGÜN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MAVİGÜN FEN LİSESİ",
    label: "ÖZEL MAVİGÜN FEN LİSESİ",
  },
  {
    value: "ÖZEL ŞAFAK ANADOLU LİSESİ",
    label: "ÖZEL ŞAFAK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL ŞAFAK MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ŞEFKAT VAKFI ÖZEL GAZİOSMANPAŞA ŞEFKAT ANADOLU LİSESİ",
    label: "ŞEFKAT VAKFI ÖZEL GAZİOSMANPAŞA ŞEFKAT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÜNGÖREN EĞİTİMDE TEK ADRES KOLEJİ (ETA) ANADOLU LİSESİ",
    label: "ÖZEL GÜNGÖREN EĞİTİMDE TEK ADRES KOLEJİ (ETA) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÜNGÖREN EKSEN ANADOLU LİSESİ",
    label: "ÖZEL GÜNGÖREN EKSEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÜNGÖREN UĞUR ANADOLU LİSESİ",
    label: "ÖZEL GÜNGÖREN UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY DİL KOLEJİ (DİLKO) ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY DİL KOLEJİ (DİLKO) ANADOLU LİSESİ",
  },
  {
    value: "FMV ÖZEL ERENKÖY IŞIK FEN LİSESİ",
    label: "FMV ÖZEL ERENKÖY IŞIK FEN LİSESİ",
  },
  {
    value: "FMV ÖZEL ERENKÖY IŞIK LİSESİ",
    label: "FMV ÖZEL ERENKÖY IŞIK LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ACIBADEM ANADOLU LİSESİ",
    label: "İSTEK ÖZEL ACIBADEM ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ACIBADEM FEN LİSESİ",
    label: "İSTEK ÖZEL ACIBADEM FEN LİSESİ",
  },
  {
    value: "İSTEK ÖZEL SEMİHA ŞAKİR ANADOLU LİSESİ",
    label: "İSTEK ÖZEL SEMİHA ŞAKİR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ACIBADEM ANADOLU LİSESİ",
    label: "ÖZEL ACIBADEM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATACAN ANADOLU LİSESİ",
    label: "ÖZEL ATACAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BAHARİYE ANADOLU LİSESİ",
    label: "ÖZEL BAHARİYE ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLİMSEL ANALİZ ANADOLU LİSESİ",
    label: "ÖZEL BİLİMSEL ANALİZ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL IRMAK ANADOLU LİSESİ",
    label: "ÖZEL IRMAK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY BİL ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY BİREY ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY DİL KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY DİL KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY EĞİTMEN ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY EĞİTMEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY EĞİTMEN FEN LİSESİ",
    label: "ÖZEL KADIKÖY EĞİTMEN FEN LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY KOŞUYOLU ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY KOŞUYOLU ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY TAM ÖĞRENME ANADOLU LİSESİ",
    label: "ÖZEL KADIKÖY TAM ÖĞRENME ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KOŞUYOLU CADDEM ANADOLU LİSESİ",
    label: "ÖZEL KOŞUYOLU CADDEM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KOŞUYOLU FİNAL ANADOLU LİSESİ",
    label: "ÖZEL KOŞUYOLU FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜRESEL EĞİTİM YAKLAŞIMI (KEY) ANADOLU LİSESİ",
    label: "ÖZEL KÜRESEL EĞİTİM YAKLAŞIMI (KEY) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SAINT JOSEPH FRANSIZ LİSESİ",
    label: "ÖZEL SAINT JOSEPH FRANSIZ LİSESİ",
  },
  {
    value: "ÖZEL YENİLİKÇİ ÖĞRENME ANADOLU LİSESİ",
    label: "ÖZEL YENİLİKÇİ ÖĞRENME ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE BİL ANADOLU LİSESİ",
    label: "ÖZEL KAĞITHANE BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE FİNAL ANADOLU LİSESİ",
    label: "ÖZEL KAĞITHANE FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE MEKTEBİM ANADOLU LİSESİ",
    label: "ÖZEL KAĞITHANE MEKTEBİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE MEKTEBİM FEN LİSESİ",
    label: "ÖZEL KAĞITHANE MEKTEBİM FEN LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE UĞUR FEN LİSESİ",
    label: "ÖZEL KAĞITHANE UĞUR FEN LİSESİ",
  },
  {
    value: "ÖZEL KAĞITHANE YÖNDER ANADOLU LİSESİ",
    label: "ÖZEL KAĞITHANE YÖNDER ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ FEN LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ FEN LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ULUĞBEY ANADOLU LİSESİ",
    label: "İSTEK ÖZEL ULUĞBEY ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL ULUĞBEY FEN LİSESİ",
    label: "İSTEK ÖZEL ULUĞBEY FEN LİSESİ",
  },
  {
    value: "ÖZEL ANADOLU KAZANIM MİLLETLERARASI LİSESİ",
    label: "ÖZEL ANADOLU KAZANIM MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL BİLGİSELİ AKŞAM LİSESİ",
    label: "ÖZEL BİLGİSELİ AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL EGE BİLİM ANADOLU LİSESİ",
    label: "ÖZEL EGE BİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ERA EĞİTİMDE RASYONEL AÇILIM KOLEJİ KARTAL ANADOLU LİSESİ",
    label: "ÖZEL ERA EĞİTİMDE RASYONEL AÇILIM KOLEJİ KARTAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL ATALAR ÇAM ANADOLU LİSESİ",
    label: "ÖZEL KARTAL ATALAR ÇAM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL KARTAL BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL DOĞA ANADOLU LİSESİ",
    label: "ÖZEL KARTAL DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL FİNAL ANADOLU LİSESİ",
    label: "ÖZEL KARTAL FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL KARTAL OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL UĞUR ANADOLU LİSESİ",
    label: "ÖZEL KARTAL UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARTAL YESEVİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL KARTAL YESEVİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KIRAÇ ANADOLU LİSESİ",
    label: "ÖZEL KIRAÇ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KARTAL ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KARTAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ORAN ANADOLU LİSESİ",
    label: "ÖZEL ORAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YAKACIK DOĞA ANADOLU LİSESİ",
    label: "ÖZEL YAKACIK DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL YAKACIK FİNAL ANADOLU LİSESİ",
    label: "ÖZEL YAKACIK FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAKENT CEZERİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL ATAKENT CEZERİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ATAKENT CEZERİ FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL ATAKENT CEZERİ FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL ATAKENT MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
    label: "ÖZEL ATAKENT MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLNET SAHİL ANADOLU LİSESİ",
    label: "ÖZEL BİLNET SAHİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CEBİRSEL MANTIK (CMA) ANADOLU LİSESİ",
    label: "ÖZEL CEBİRSEL MANTIK (CMA) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CİHANGİR ANADOLU LİSESİ",
    label: "ÖZEL CİHANGİR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAĞDAŞ BİLİMLER KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÇAĞDAŞ BİLİMLER KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ FLORYA ANADOLU LİSESİ",
    label: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ FLORYA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FLORYA DOĞA ANADOLU LİSESİ",
    label: "ÖZEL FLORYA DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKBORA TEKNOKENT MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL GÖKBORA TEKNOKENT MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HALKALI ATAKENT DOĞA ANADOLU LİSESİ",
    label: "ÖZEL HALKALI ATAKENT DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HALKALI ATAKENT DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL HALKALI ATAKENT DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL HALKALI BİLTEK ANADOLU LİSESİ",
    label: "ÖZEL HALKALI BİLTEK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HALKALI FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL HALKALI FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HALKALI UĞUR ANADOLU LİSESİ",
    label: "ÖZEL HALKALI UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İHSAN ATAKENT ANADOLU LİSESİ",
    label: "ÖZEL İHSAN ATAKENT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL BİLİM ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL BİLİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL BİLİM FEN LİSESİ",
    label: "ÖZEL İSTANBUL BİLİM FEN LİSESİ",
  },
  {
    value: "ÖZEL KÜÇÜKÇEKMECE HALKALI OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL KÜÇÜKÇEKMECE HALKALI OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜÇÜKÇEKMECE SINAV ANADOLU LİSESİ",
    label: "ÖZEL KÜÇÜKÇEKMECE SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL OĞUZKAAN KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL OĞUZKAAN KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL OĞUZKAAN KOLEJİ FEN LİSESİ",
    label: "ÖZEL OĞUZKAAN KOLEJİ FEN LİSESİ",
  },
  {
    value: "ÖZEL SEFAKÖY HAZAR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL SEFAKÖY HAZAR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SEFAKÖY UĞUR ANADOLU LİSESİ",
    label: "ÖZEL SEFAKÖY UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SOYAK FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL SOYAK FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TEMA PARK BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL TEMA PARK BAHÇEŞEHİR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TEMA PARK BAHÇEŞEHİR KOLEJİ FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL TEMA PARK BAHÇEŞEHİR KOLEJİ FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "TED ÖZEL ATAKENT ANADOLU LİSESİ",
    label: "TED ÖZEL ATAKENT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL GÖKTÜRK ANADOLU LİSESİ",
    label: "ÖZEL GÖKTÜRK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARACA AKŞAM LİSESİ",
    label: "ÖZEL KARACA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE CEVİZLİ UĞUR ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE CEVİZLİ UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE FİNAL ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE KAYRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE KAYRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE TARHAN ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE TARHAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE TERCİH AKŞAM LİSESİ",
    label: "ÖZEL MALTEPE TERCİH AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE TERCİH MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE TERCİH MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE UĞUR ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE UĞURLU FEN BİLİMLERİ UĞURLU EĞİTİM ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE UĞURLU FEN BİLİMLERİ UĞURLU EĞİTİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE YÖNDER ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE YÖNDER ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MALTEPE ZÜMRÜTEVLER NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL MALTEPE ZÜMRÜTEVLER NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MARMARA FEN LİSESİ",
    label: "ÖZEL MARMARA FEN LİSESİ",
  },
  {
    value: "ÖZEL MARMARA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL MARMARA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SONUÇ ONİKİ ANADOLU LİSESİ",
    label: "ÖZEL SONUÇ ONİKİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TED RÖNESANS ANADOLU LİSESİ",
    label: "ÖZEL TED RÖNESANS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ PENDİK ANADOLU LİSESİ",
    label: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ PENDİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALİ GÜNGÖR ANADOLU LİSESİ",
    label: "ÖZEL ALİ GÜNGÖR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BALKANLAR KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL BALKANLAR KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BUĞRA AKŞAM LİSESİ",
    label: "ÖZEL BUĞRA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL BUĞRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL BUĞRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CEBİR ANADOLU LİSESİ",
    label: "ÖZEL CEBİR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CEBİR FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL CEBİR FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL ERYETİŞ REİS DENİZCİLİK MESLEK LİSESİ",
    label: "ÖZEL ERYETİŞ REİS DENİZCİLİK MESLEK LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY AKŞAM LİSESİ",
    label: "ÖZEL KURTKÖY AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY BAYRAMLAR ANADOLU LİSESİ",
    label: "ÖZEL KURTKÖY BAYRAMLAR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY DOĞA ANADOLU LİSESİ",
    label: "ÖZEL KURTKÖY DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
    label: "ÖZEL KURTKÖY MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
    label: "ÖZEL KURTKÖY MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
  },
  {
    value: "ÖZEL KURTKÖY UĞUR ANADOLU LİSESİ",
    label: "ÖZEL KURTKÖY UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NASİBE ERYETİŞ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL NASİBE ERYETİŞ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KURTKÖY ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KURTKÖY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KURTKÖY FEN LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ KURTKÖY FEN LİSESİ",
  },
  {
    value: "ÖZEL PENDİK AÇI ANADOLU LİSESİ",
    label: "ÖZEL PENDİK AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK BİL ANADOLU LİSESİ",
    label: "ÖZEL PENDİK BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK BİLTEK ANADOLU LİSESİ",
    label: "ÖZEL PENDİK BİLTEK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK BİREY ANADOLU LİSESİ",
    label: "ÖZEL PENDİK BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK BİRİKİM KIZ ANADOLU LİSESİ",
    label: "ÖZEL PENDİK BİRİKİM KIZ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK ÇÖZÜM AKADEMİ AKŞAM LİSESİ",
    label: "ÖZEL PENDİK ÇÖZÜM AKADEMİ AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL PENDİK ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL PENDİK ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL PENDİK FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK İKBAL ANADOLU LİSESİ",
    label: "ÖZEL PENDİK İKBAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK OĞUZ FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL PENDİK OĞUZ FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL PENDİK RASYONEL TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL PENDİK RASYONEL TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK UĞUR ANADOLU LİSESİ",
    label: "ÖZEL PENDİK UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK YÖNDER ANADOLU LİSESİ",
    label: "ÖZEL PENDİK YÖNDER ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PENDİK YÖNDER FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL PENDİK YÖNDER FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL TURKUAZ EĞİTİM KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL TURKUAZ EĞİTİM KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TURKUAZ TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL TURKUAZ TEKNOLOJİ KOLEJİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ SANCAKTEPE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ SANCAKTEPE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KÜÇÜK PRENS LİSESİ",
    label: "ÖZEL KÜÇÜK PRENS LİSESİ",
  },
  {
    value: "ÖZEL SAMANDIRA SAFA ANADOLU LİSESİ",
    label: "ÖZEL SAMANDIRA SAFA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE BATI FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE BATI FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE BİRİKİM ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE BİRİKİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE BİRİKİM FEN LİSESİ",
    label: "ÖZEL SANCAKTEPE BİRİKİM FEN LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE KAVRAM ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE KAVRAM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE OKYANUS ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE OKYANUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE SINAV ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE TERCİH ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE TERCİH ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SANCAKTEPE UĞUR ANADOLU LİSESİ",
    label: "ÖZEL SANCAKTEPE UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TERCİH MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL TERCİH MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "FMV ÖZEL AYAZAĞA IŞIK FEN LİSESİ",
    label: "FMV ÖZEL AYAZAĞA IŞIK FEN LİSESİ",
  },
  {
    value: "FMV ÖZEL AYAZAĞA IŞIK LİSESİ",
    label: "FMV ÖZEL AYAZAĞA IŞIK LİSESİ",
  },
  {
    value: "İSTEK ÖZEL KEMAL ATATÜRK ANADOLU LİSESİ",
    label: "İSTEK ÖZEL KEMAL ATATÜRK ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL KEMAL ATATÜRK FEN LİSESİ",
    label: "İSTEK ÖZEL KEMAL ATATÜRK FEN LİSESİ",
  },
  {
    value: "İTÜ GELİŞTİRME VAKFI ÖZEL EKREM ELGİNKAN LİSESİ",
    label: "İTÜ GELİŞTİRME VAKFI ÖZEL EKREM ELGİNKAN LİSESİ",
  },
  {
    value: "ÖZEL DARUŞŞAFAKA LİSESİ",
    label: "ÖZEL DARUŞŞAFAKA LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEKÖY AÇI LİSESİ",
    label: "ÖZEL BAHÇEKÖY AÇI LİSESİ",
  },
  {
    value: "ÖZEL BAHÇEKÖY AÇI SOSYAL BİLİMLER LİSESİ",
    label: "ÖZEL BAHÇEKÖY AÇI SOSYAL BİLİMLER LİSESİ",
  },
  {
    value: "ÖZEL BİS ANADOLU LİSESİ",
    label: "ÖZEL BİS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BOĞAZİÇİ EĞİTİM İLGİ ANADOLU LİSESİ",
    label: "ÖZEL BOĞAZİÇİ EĞİTİM İLGİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CENT LİSESİ",
    label: "ÖZEL CENT LİSESİ",
  },
  {
    value: "ÖZEL ENKA LİSESİ",
    label: "ÖZEL ENKA LİSESİ",
  },
  {
    value: "ÖZEL MÜRÜVVET EVYAP FEN LİSESİ",
    label: "ÖZEL MÜRÜVVET EVYAP FEN LİSESİ",
  },
  {
    value: "ÖZEL SARIYER BRITISH INTERNATIONAL SCHOOL (LİSE)",
    label: "ÖZEL SARIYER BRITISH INTERNATIONAL SCHOOL (LİSE)",
  },
  {
    value: "ÖZEL SARIYER DOĞA ANADOLU LİSESİ",
    label: "ÖZEL SARIYER DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SARIYER DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL SARIYER DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL SARIYER MERİDYEN ANADOLU LİSESİ",
    label: "ÖZEL SARIYER MERİDYEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TARABYA ANADOLU LİSESİ",
    label: "ÖZEL TARABYA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TARABYA ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL TARABYA ÇÖZÜM AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TÜMEVARIM ANADOLU LİSESİ",
    label: "ÖZEL TÜMEVARIM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL US ULUS ANADOLU LİSESİ",
    label: "ÖZEL US ULUS ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ SINAV ANADOLU LİSESİ",
    label: "ÖZEL SİLİVRİ SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL YILDIRIM AKŞAM LİSESİ",
    label: "ÖZEL İSTANBUL YILDIRIM AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL KOREAN SCHOOL İNTERNATİONAL MİLLETLERARASI LİSESİ",
    label: "ÖZEL KOREAN SCHOOL İNTERNATİONAL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ SİLİVRİ ANADOLU LİSESİ",
    label: "ÖZEL NAZMİ ARIKAN FEN BİLİMLERİ SİLİVRİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ ÇİZGİ YAZILIM ANADOLU LİSESİ",
    label: "ÖZEL SİLİVRİ ÇİZGİ YAZILIM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ DENİZ AKŞAM LİSESİ",
    label: "ÖZEL SİLİVRİ DENİZ AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ FİNAL ANADOLU LİSESİ",
    label: "ÖZEL SİLİVRİ FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ MEKTEBİM ANADOLU LİSESİ",
    label: "ÖZEL SİLİVRİ MEKTEBİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SİLİVRİ MEKTEBİM FEN LİSESİ",
    label: "ÖZEL SİLİVRİ MEKTEBİM FEN LİSESİ",
  },
  {
    value:
      "ÖZEL SİLİVRİ TARIMSAL ÜRETİM ARAŞTIRMA MERKEZİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label:
      "ÖZEL SİLİVRİ TARIMSAL ÜRETİM ARAŞTIRMA MERKEZİ MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARDELEN MESLEK VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL KARDELEN MESLEK VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALTINAY LİSESİ",
    label: "ÖZEL ALTINAY LİSESİ",
  },
  {
    value: "ÖZEL BİLGİ ÇAĞI ANADOLU LİSESİ",
    label: "ÖZEL BİLGİ ÇAĞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KARDELEN ANADOLU LİSESİ",
    label: "ÖZEL KARDELEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SULTANBEYLİ DÜZGÜN AKŞAM LİSESİ",
    label: "ÖZEL SULTANBEYLİ DÜZGÜN AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL SULTANBEYLİ ELÇİ AKŞAM LİSESİ",
    label: "ÖZEL SULTANBEYLİ ELÇİ AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL SULTANBEYLİ ELİT AKŞAM LİSESİ",
    label: "ÖZEL SULTANBEYLİ ELİT AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL SULTANBEYLİ KARDELEN MESLEKİ VE TEKNİK ANADOLU LİSES",
    label: "ÖZEL SULTANBEYLİ KARDELEN MESLEKİ VE TEKNİK ANADOLU LİSES",
  },
  {
    value: "ÖZEL SULTANBEYLİ KAYRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL SULTANBEYLİ KAYRA MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SULTANBEYLİ UĞUR ANADOLU LİSESİ",
    label: "ÖZEL SULTANBEYLİ UĞUR ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL KAŞGARLI MAHMUT ANADOLU LİSESİ",
    label: "İSTEK ÖZEL KAŞGARLI MAHMUT ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL KAŞGARLI MAHMUT FEN LİSESİ",
    label: "İSTEK ÖZEL KAŞGARLI MAHMUT FEN LİSESİ",
  },
  {
    value: "ÖZEL EL MENAHİL MİLLETLERARASI LİSESİ",
    label: "ÖZEL EL MENAHİL MİLLETLERARASI LİSESİ",
  },
  {
    value: "ÖZEL SEYİT ATEŞ SPOR LİSESİ",
    label: "ÖZEL SEYİT ATEŞ SPOR LİSESİ",
  },
  {
    value: "ÖZEL SULTANGAZİ BİRİKİM ANADOLU LİSESİ",
    label: "ÖZEL SULTANGAZİ BİRİKİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLGİ KURAM ANADOLU LİSESİ",
    label: "ÖZEL BİLGİ KURAM ANADOLU LİSESİ",
  },
  {
    value: "FMV ÖZEL IŞIK LİSESİ",
    label: "FMV ÖZEL IŞIK LİSESİ",
  },
  {
    value: "ÖZEL FİNAL ANADOLU LİSESİ",
    label: "ÖZEL FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BEŞİKTAŞ SINAV ANADOLU LİSESİ",
    label: "ÖZEL BEŞİKTAŞ SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DOĞRU NETİCE ANADOLU LİSESİ",
    label: "ÖZEL DOĞRU NETİCE ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ BOMONTİ ANADOLU LİSESİ",
    label: "ÖZEL EĞİTİMDE RASYONEL AÇILIM (ERA) KOLEJİ BOMONTİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL EŞREF AYDIN AKŞAM LİSESİ",
    label: "ÖZEL EŞREF AYDIN AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL EŞREF AYDIN ANADOLU LİSESİ",
    label: "ÖZEL EŞREF AYDIN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MECİDİYEKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL MECİDİYEKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NİLGÜN DOĞAY ANADOLU LİSESİ",
    label: "ÖZEL NİLGÜN DOĞAY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NOTRE DAME DE SION FRANSIZ LİSESİ",
    label: "ÖZEL NOTRE DAME DE SION FRANSIZ LİSESİ",
  },
  {
    value: "ÖZEL PANGALTI ERMENİ ANADOLU LİSESİ",
    label: "ÖZEL PANGALTI ERMENİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL PERA GÜZEL SANATLAR LİSESİ",
    label: "ÖZEL PERA GÜZEL SANATLAR LİSESİ",
  },
  {
    value: "ÖZEL SAINT MICHEL FRANSIZ LİSESİ",
    label: "ÖZEL SAINT MICHEL FRANSIZ LİSESİ",
  },
  {
    value: "ÖZEL ŞİŞLİ BİLİM DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ŞİŞLİ BİLİM DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ŞİŞLİ KIRAÇ FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ŞİŞLİ KIRAÇ FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL ZİNCİRLİKUYU CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
    label:
      "ÖZEL ZİNCİRLİKUYU CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL FEN EĞİTİM BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL FEN EĞİTİM BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL OKAN ANADOLU LİSESİ",
    label: "ÖZEL OKAN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA AÇI ANADOLU LİSESİ",
    label: "ÖZEL TUZLA AÇI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA BİREY ANADOLU LİSESİ",
    label: "ÖZEL TUZLA BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA DOĞA ANADOLU LİSESİ",
    label: "ÖZEL TUZLA DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL TUZLA DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL TUZLA EĞİTMEN ANADOLU LİSESİ",
    label: "ÖZEL TUZLA EĞİTMEN ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL TUZLA EĞİTSEL DEĞER UYGULAMALARI KENT (EDUKENT) ANADOLU LİSESİ",
    label:
      "ÖZEL TUZLA EĞİTSEL DEĞER UYGULAMALARI KENT (EDUKENT) ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA KALE ANADOLU LİSESİ",
    label: "ÖZEL TUZLA KALE ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA KALE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL TUZLA KALE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA MARMARA KALE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
    label: "ÖZEL TUZLA MARMARA KALE MESLEKİ VE TEKNİK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TUZLA UĞUR ANADOLU LİSESİ",
    label: "ÖZEL TUZLA UĞUR ANADOLU LİSESİ",
  },
  {
    value: "TERAKKİ VAKFI ÖZEL ŞİŞLİ TERAKKİ TEPEÖREN ANADOLU LİSESİ",
    label: "TERAKKİ VAKFI ÖZEL ŞİŞLİ TERAKKİ TEPEÖREN ANADOLU LİSESİ",
  },
  {
    value: "VEHBİ KOÇ VAKFI KOÇ ÖZEL LİSESİ",
    label: "VEHBİ KOÇ VAKFI KOÇ ÖZEL LİSESİ",
  },
  {
    value: "ÖZEL BURÇAK EYÜBOĞLU FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL BURÇAK EYÜBOĞLU FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL ÇAĞIN ANADOLU LİSESİ",
    label: "ÖZEL ÇAĞIN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇEKMEKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ÇEKMEKÖY NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DUDULLU TERCİH ANADOLU LİSESİ",
    label: "ÖZEL DUDULLU TERCİH ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DUDULLU TERCİH AKŞAM LİSESİ",
    label: "ÖZEL DUDULLU TERCİH AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL FİKRİ İDEAL OKULLARI ANADOLU LİSESİ",
    label: "ÖZEL FİKRİ İDEAL OKULLARI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İRFAN FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL İRFAN FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL ERDEM ANADOLU LİSESİ",
    label: "ÖZEL İSTANBUL ERDEM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İTİNA AKŞAM LİSESİ",
    label: "ÖZEL İTİNA AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL İTİNA ANADOLU LİSESİ",
    label: "ÖZEL İTİNA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL KAPI ULUSLARARASI LİSESİ",
    label: "ÖZEL KAPI ULUSLARARASI LİSESİ",
  },
  {
    value: "ÖZEL MADENLER BİREY ANADOLU LİSESİ",
    label: "ÖZEL MADENLER BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MADENLER UĞUR ANADOLU LİSESİ",
    label: "ÖZEL MADENLER UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MADENLER UĞUR FEN LİSESİ",
    label: "ÖZEL MADENLER UĞUR FEN LİSESİ",
  },
  {
    value: "ÖZEL Pİ KARE ANADOLU LİSESİ",
    label: "ÖZEL Pİ KARE ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL SOYAK YENİŞEHİR KAVRAM ANADOLU LİSESİ",
    label: "ÖZEL SOYAK YENİŞEHİR KAVRAM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ŞERİFALİ ÇÖZÜM AKADEMİ OKULLARI ANADOLU LİSESİ",
    label: "ÖZEL ŞERİFALİ ÇÖZÜM AKADEMİ OKULLARI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL UMUT AKŞAM LİSESİ",
    label: "ÖZEL UMUT AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE AŞAMA ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE AŞAMA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE BİL ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE BİL FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL ÜMRANİYE BİL FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE BİRİKİM ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE BİRİKİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE ÇAĞIN AKŞAM LİSESİ",
    label: "ÖZEL ÜMRANİYE ÇAĞIN AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE FİNAL AKADEMİ ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE FİNAL AKADEMİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE GEN ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE GEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
    label: "ÖZEL ÜMRANİYE MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE NAZMİ ARIKAN FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE NİL FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE NİL FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE SINAV ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE UĞUR ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE UĞURLU FEN BİLİMLERİ UĞURLU EĞİTİM ANADOLU LİSESİ",
    label: "ÖZEL ÜMRANİYE UĞURLU FEN BİLİMLERİ UĞURLU EĞİTİM ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜMRANİYE USUL AKŞAM LİSESİ",
    label: "ÖZEL ÜMRANİYE USUL AKŞAM LİSESİ",
  },
  {
    value: "BJK KABATAŞ VAKFI ÖZEL ANADOLU LİSESİ",
    label: "BJK KABATAŞ VAKFI ÖZEL ANADOLU LİSESİ",
  },
  {
    value: "BJK KABATAŞ VAKFI ÖZEL FEN VE TEKNOLOJİ LİSESİ",
    label: "BJK KABATAŞ VAKFI ÖZEL FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "İSTEK ÖZEL BELDE ANADOLU LİSESİ",
    label: "İSTEK ÖZEL BELDE ANADOLU LİSESİ",
  },
  {
    value: "İSTEK ÖZEL BELDE FEN LİSESİ",
    label: "İSTEK ÖZEL BELDE FEN LİSESİ",
  },
  {
    value: "KALEM VAKFI ÖZEL ÇAMLICA ANADOLU LİSESİ",
    label: "KALEM VAKFI ÖZEL ÇAMLICA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ACIBADEM BİLİM DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ACIBADEM BİLİM DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ACIBADEM DOĞA FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL ACIBADEM DOĞA FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL ACIBADEM SINAV ANADOLU LİSESİ",
    label: "ÖZEL ACIBADEM SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALTUNİZADE FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ALTUNİZADE FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ALTUNİZADE SEVİNÇ ANADOLU LİSESİ",
    label: "ÖZEL ALTUNİZADE SEVİNÇ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ASFA AHMET MİTHAT ANADOLU LİSESİ",
    label: "ÖZEL ASFA AHMET MİTHAT ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ASFA FEN LİSESİ",
    label: "ÖZEL ASFA FEN LİSESİ",
  },
  {
    value: "ÖZEL BİLFEN ANADOLU LİSESİ",
    label: "ÖZEL BİLFEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL BİLFEN ÜSKÜDAR FEN LİSESİ",
    label: "ÖZEL BİLFEN ÜSKÜDAR FEN LİSESİ",
  },
  {
    value: "ÖZEL BİLTEK ANADOLU LİSESİ",
    label: "ÖZEL BİLTEK ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA BİL AKŞAM LİSESİ",
    label: "ÖZEL ÇAMLICA BİL AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA BİL ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA BİL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA BİRİKİM ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA BİRİKİM ANADOLU LİSESİ",
  },
  {
    value:
      "ÖZEL ÇAMLICA CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
    label:
      "ÖZEL ÇAMLICA CEBİRSEL EĞİTİM VE RASYONEL NİTELİK (CERN) KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA DOĞA ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA MODERN BİLİMLER AKADEMİSİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
    label: "ÖZEL ÇAMLICA MODERN BİLİMLER AKADEMİSİ FEN LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA OĞUZ FEN BİLİMLERİ ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA OĞUZ FEN BİLİMLERİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇAMLICA UĞUR ANADOLU LİSESİ",
    label: "ÖZEL ÇAMLICA UĞUR ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÇENGELKÖY FİNAL ANADOLU LİSESİ",
    label: "ÖZEL ÇENGELKÖY FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DERYA ÖNCÜ ANADOLU LİSESİ",
    label: "ÖZEL DERYA ÖNCÜ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL DOĞAN KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL DOĞAN KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL HAVVA EKŞİ BÜKEN ANADOLU LİSESİ",
    label: "ÖZEL HAVVA EKŞİ BÜKEN ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL FEN LİSESİ",
    label: "ÖZEL İSTANBUL FEN LİSESİ",
  },
  {
    value: "ÖZEL İSTANBUL INTERNATIONAL LİSESİ",
    label: "ÖZEL İSTANBUL INTERNATIONAL LİSESİ",
  },
  {
    value: "ÖZEL KADIKÖY AKŞAM LİSESİ",
    label: "ÖZEL KADIKÖY AKŞAM LİSESİ",
  },
  {
    value: "ÖZEL KEYSTONE ULUSLARARASI LİSESİ",
    label: "ÖZEL KEYSTONE ULUSLARARASI LİSESİ",
  },
  {
    value: "ÖZEL MODA MİMAR SİNAN ANADOLU GÜZEL SANATLAR LİSESİ",
    label: "ÖZEL MODA MİMAR SİNAN ANADOLU GÜZEL SANATLAR LİSESİ",
  },
  {
    value: "ÖZEL NAKKAŞTEPE BAHÇEŞEHİR KOLEJİ 50. YIL ANADOLU LİSESİ",
    label: "ÖZEL NAKKAŞTEPE BAHÇEŞEHİR KOLEJİ 50. YIL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL NAKKAŞTEPE BAHÇEŞEHİR KOLEJİ 50. YIL FEN VE TEKNOLOJİ LİSESİ",
    label: "ÖZEL NAKKAŞTEPE BAHÇEŞEHİR KOLEJİ 50. YIL FEN VE TEKNOLOJİ LİSESİ",
  },
  {
    value: "ÖZEL SURP HAÇ ERMENİ LİSESİ",
    label: "ÖZEL SURP HAÇ ERMENİ LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR AMERİKAN LİSESİ",
    label: "ÖZEL ÜSKÜDAR AMERİKAN LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR BAĞLARBAŞI ANADOLU LİSESİ",
    label: "ÖZEL ÜSKÜDAR BAĞLARBAŞI ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR BİREY ANADOLU LİSESİ",
    label: "ÖZEL ÜSKÜDAR BİREY ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR SINAV ANADOLU LİSESİ",
    label: "ÖZEL ÜSKÜDAR SINAV ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR SINAV KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÜSKÜDAR SINAV KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL ÜSKÜDAR TÜRK EĞİTİM DERNEĞİ KOLEJİ ANADOLU LİSESİ",
    label: "ÖZEL ÜSKÜDAR TÜRK EĞİTİM DERNEĞİ KOLEJİ ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL CEVİZLİBAĞ DOĞA ANADOLU LİSESİ",
    label: "ÖZEL CEVİZLİBAĞ DOĞA ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL MERTER FİNAL ANADOLU LİSESİ",
    label: "ÖZEL MERTER FİNAL ANADOLU LİSESİ",
  },
  {
    value: "ÖZEL TOPKAPI UĞUR ANADOLU LİSESİ",
    label: "ÖZEL TOPKAPI UĞUR ANADOLU LİSESİ",
  },
];
